import {Identifiable} from './identifiable';
import {Project} from './project';
import {TeamMember} from './team-member';

export type ProjectReferenceStatus = 'Concept' | 'Published';

export interface ProjectReference extends Identifiable {
    status: ProjectReferenceStatus;
    createdAt: Date;
    createdBy: string;
    updatedAt: Date;
    updatedBy: string;
    project: Project;
}

export const referenceStatusTranslation = {
    Concept: 'Concept',
    Published: 'Gepubliceerd'
};
